import React, { Component } from "react";
import { Elements, StripeProvider } from "react-stripe-elements";
import { Button, PageHeader, DropdownButton, MenuItem, Panel, Row,Tab, Tabs, Col } from "react-bootstrap";
import ModalCreateFolder        from "../../components/modal/ModalCreateFolder";
import ModalMoveProgramToFolder from "../../components/modal/ModalMoveProgramToFolder";
import uniqueId                 from 'lodash/uniqueId';
import config                   from "../../config";
import RenderLander             from "../../components/utils/RenderLander";
import BillingForm              from "../../screens/billing/BillingForm";
import { Colors }               from "../../utils/Colors";
import TrainerList              from "../../screens/trainer/TrainerList";
import TemplateAnalysis              from "../../screens/trainer/TemplateAnalysis";
import { TS_LU, TS_ASP, TS_JC }        from "../../utils/StaticIds";
import "../../css/utils/Settings.css";


const p4l_castro = "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30";
const p4l_fidi   = "c84934b0-ebf0-11e9-911a-fbdac363f28e";
const p4l_hayes  = "001877c0-ebf1-11e9-a945-d5dded95ac71";
const asp_id     = "9a7af3c4-97b1-11e7-9e5d-f78105fd617e";

export default class SettingHome extends Component {
    constructor(props) {
        super(props);
        var globalAdminUserEmail       = localStorage.getItem('globalAdminUserEmail');
        var globalAdminUserRoleId      = localStorage.getItem('globalAdminUserRoleId');
        var globalTrainerOnTrialPeriod = localStorage.getItem('globalTrainerOnTrialPeriod');

        this.state = {
          isLoading: true,
          exerciseSaved: false,
          showTemplateAnalysis: false,
          adminUserEmail: globalAdminUserEmail,
          adminUserRoleId: globalAdminUserRoleId,
          trainerOnTrialPeriod: globalTrainerOnTrialPeriod
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.settings();
        } catch (e) {
            alert(e);
        }
    }

    settings () {
        var exerciseVideoOption = localStorage.getItem('exercise_video_options');

        if(exerciseVideoOption == null) exerciseVideoOption = 'allvideos'

        this.setState({
             selectedOption: exerciseVideoOption
        });
    }

    handleOptionChange = (event) => {
        var option = event.target.value;
        localStorage.setItem('exercise_video_options', option);

        this.setState({
                selectedOption: option,
                exerciseSaved: true
        });

        setTimeout(
            function() {
                this.setState({exerciseSaved: false});
            }
            .bind(this), 2000
        );
    }

    async handleFormSubmit(storage, { token, error }) {
        if (error) {
            alert(error);
            return;
        }

        //setIsLoading(true);

        try {
            await this.billUser({
              storage,
              source: token.id
            });

            alert("Your card has been charged successfully!");
            //props.history.push("/");
        } catch (e) {
            alert(e);
            //setIsLoading(false);
        }
    }

    billUser(details) {
        /*return API.post("notes", "/billing", {
          body: details
        });*/
    }

    getAdminUserId = () => {
       var globalAdminUserId = localStorage.getItem('globalAdminUserId');
       return globalAdminUserId;
    }

    handleTabSelect = (key) => {

        var showTemplateAnalysis = false;
        if(key === 3) showTemplateAnalysis = true

        this.setState({showTemplateAnalysis: showTemplateAnalysis});
    }

    renderHome() {
        var customer_company = this.props.globalCompanyName; //process.env.REACT_APP_COMPANY_NAME;
        var exercise_saved;
        var tab2 = <div></div>;
        var tab3, tab4;
        var adminUserRoleId = this.state.adminUserRoleId;
        var user_role       = "Trainer/Instructor";
        var show_trainers   = false;
        var company_id      = this.props.globalCompanyId;
        var globalAdminUserId = this.getAdminUserId()
        //console.log("adminUserRoleId: " + adminUserRoleId);

        if(company_id == p4l_castro || company_id == p4l_fidi || company_id == p4l_hayes || company_id == asp_id) show_trainers = true;

        if(adminUserRoleId == 10) {
            user_role = "Administrator";
            tab2 = <Tab eventKey={2} title="Trainers">
                        <TrainerList globalCompanyId = {company_id}/>
                   </Tab>
        }

        if(adminUserRoleId == 10 && show_trainers)
            tab3 = <Tab eventKey={3} title="Billing">
                        <StripeProvider apiKey={config.STRIPE_KEY}>
                          <Elements>
                            <BillingForm
                              isLoading={this.state.isLoading}
                              onSubmit={this.handleFormSubmit}
                            />
                          </Elements>
                        </StripeProvider>
                   </Tab>

       var showTemplateTab;
       var trial = "No"

       if(this.state.trainerOnTrialPeriod == "true") {
            trial = "Yes"
        }

       if(this.state.showTemplateAnalysis)
            showTemplateTab = <TemplateAnalysis globalCompanyId = {company_id}
                                                isAuthenticated = {this.props.isAuthenticated}/>;

       if(globalAdminUserId == TS_LU || globalAdminUserId == TS_JC )
           tab4 = <Tab eventKey={3} title="Reports">
                       {showTemplateTab}
                  </Tab>

        if(this.state.exerciseSaved)
            exercise_saved   = "Selection Saved.";

        return (
              <div className="programs">
                <PageHeader>
                    <span className="glyphicon glyphicon-cog" style={{ position:"relative", top:5, fontSize: '1em', color: Colors.primary_color, paddingRight:"16px" }}/>
                    Settings
                </PageHeader>
                <br/>
                    <Tabs defaultActiveKey={1}
                          id="uncontrolled-tab-example"
                          onSelect={this.handleTabSelect}>
                              <Tab eventKey={1} title="General">
                                        <br/><br/>

                                        <Row className="grid">
                                                  {/*}<span className="glyphicon glyphicon-list glyphIconLink"></span>
                                                    <div className="iconHomeVertSpacer"></div>*/ }
                                                      <div className="homeMainLink" style={{display:"inline-block", position:"relative", left: 20}}>
                                                         <b>Email: </b>{ this.state.adminUserEmail }
                                                      </div>
                                                      <br/><br/>
                                                      <div className="homeMainLink" style={{display:"inline-block", position:"relative", left: 20}}>
                                                         <b>Role: </b>{ user_role }
                                                      </div>
                                                      <br/><br/>
                                                      <div className="homeMainLink" style={{display:"inline-block", position:"relative", left: 20}}>
                                                         <b>On Trial Period: </b>{ trial }
                                                      </div>
                                                      <br/><br/>

                                                      <div className="homeMainLink" style={{display:"inline-block", position:"relative", left: 20}}>
                                                          <b>Show These Exercise Videos in Exercise Library</b>
                                                      </div>

                                                      <div>
                                                          <label className="settingsExercRadioBtns">
                                                                <input type="radio"
                                                                       value="allvideos"
                                                                       checked={this.state.selectedOption === 'allvideos'}
                                                                       onChange={this.handleOptionChange} />
                                                                   <span className="radioBtnSettingsExerciseLabel">All videos: Training Slate  & { customer_company } videos</span>
                                                          </label>
                                                      </div>
                                                      <label className="settingsExercRadioBtns">
                                                            <input type="radio"
                                                                   value="customvideos"
                                                                   checked={this.state.selectedOption === 'customvideos'}
                                                                   onChange={this.handleOptionChange} />
                                                               <div className="radioBtnSettingsExerciseLabel">Only my videos { /*}: { customer_company } videos*/ }</div>
                                                      </label>
                                                      <div className="settingsExerciseSaved">{ exercise_saved }</div>
                                                  <br/><br/>
                                        </Row>
                                    </Tab>
                            { tab2 }
                            { /*tab3*/ }
                            { tab4 }
                  </Tabs>
              </div>
        );
    }

    render() {
        let closeModalCreateFolder = () => this.setState({ showModalCreateFolder: false }); //close simple modal window
        let closeModalMoveProgram  = () => this.setState({ showModalMoveProgram: false }); //close simple modal window
        return (
              <div className="Home">
                {this.renderHome() }

                  {this.state.showModalCreateFolder ?
                      <ModalCreateFolder
                          show={this.state.showModalCreateFolder}
                          onHide={closeModalCreateFolder}
                          getProgramList={this.getProgramList}
                      />
                  : null}
                  {this.state.showModalMoveProgram ?
                      <ModalMoveProgramToFolder
                          show={this.state.showModalMoveProgram}
                          onHide={closeModalMoveProgram}
                          program_id={this.state.program_id}
                          getProgramList={this.getProgramList}
                      />
                  : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/setting/Setting.js